import InstantApp from '../InstantApp'
import settings from './settings'
import customFields from './customFields'
import { SOCIAL } from 'constants/templateCategory'
import thumbnail from '../assets/thumbnail.jpeg'

export const information = {
  id: 'coffee',
  title: 'Social Slider',
  image: thumbnail,
  thumbnailPath: [ 'scene2', 'bg' ],
  category: SOCIAL,
  description: 'Encourage users to share product on social networks.',
  integrations: [],
  instantApp: InstantApp,
  defaultSettings: settings,
}

export function getTemplate (app) {
  return {
    id: 'coffee',
    customFields,
    settings
  }
}



// WEBPACK FOOTER //
// ./src/templates/coffee/template/index.js